import { ValidationError } from '../types'

/**
 * Localize validation error messages
 * This utility function converts hardcoded Chinese error messages from backend
 * to internationalized messages using react-i18next
 */
export const localizeValidationError = (error: ValidationError, t: (key: string, options?: any) => string): ValidationError => {
  const { message } = error
  
  // Extract milestone name and other parameters from Chinese error messages
  const missingOwnerMatch = message.match(/里程碑"(.+?)"缺少负责人/)
  const missingSubtasksMatch = message.match(/里程碑"(.+?)"缺少子任务/)
  const missingTaskNameMatch = message.match(/里程碑"(.+?)"的第(\d+)个子任务缺少任务名称/)
  const missingAssigneeMatch = message.match(/里程碑"(.+?)"的第(\d+)个子任务缺少负责人/)
  
  if (missingOwnerMatch) {
    return {
      ...error,
      message: t('planManagement.assignment.validation.missingOwner', { milestoneName: missingOwnerMatch[1] })
    }
  }
  
  if (missingSubtasksMatch) {
    return {
      ...error,
      message: t('planManagement.assignment.validation.missingSubtasks', { milestoneName: missingSubtasksMatch[1] })
    }
  }
  
  if (missingTaskNameMatch) {
    return {
      ...error,
      message: t('planManagement.assignment.validation.missingTaskName', { 
        milestoneName: missingTaskNameMatch[1], 
        index: missingTaskNameMatch[2] 
      })
    }
  }
  
  if (missingAssigneeMatch) {
    return {
      ...error,
      message: t('planManagement.assignment.validation.missingAssignee', { 
        milestoneName: missingAssigneeMatch[1], 
        index: missingAssigneeMatch[2] 
      })
    }
  }
  
  // Return original error if no match found
  return error
}

/**
 * Batch localize validation errors
 */
export const localizeValidationErrors = (errors: ValidationError[], t: (key: string, options?: any) => string): ValidationError[] => {
  return errors.map(error => localizeValidationError(error, t))
}